import React from 'react';

import { DeleteConfirmationModal } from '@dndbeyond/character-common-components/es';

import { ThemeButton } from '../ThemeButton';

// TODO: remove and use character-components/Button/RemoveButtonWithModal with theme override when needed

interface Props {
    onClick?: () => void;
    children?: React.ReactNode;
    className?: string;
    disabled?: boolean;
    styledDisabled?: boolean;
    block?: boolean;
    size?: string;
    style?: string;
    active?: boolean;
    stopPropagation?: boolean;
    enableConfirm?: boolean;
    isInteractive?: boolean;
    modalTitle: string;
    modalContent: React.ReactNode;
    modalPrimaryButtonText?: string;
    confirmCallback?: () => void;
    cancelCallBack?: () => void;
}

export default function RemoveButtonWithModal({
    children,
    className,
    modalTitle,
    modalContent,
    modalPrimaryButtonText = 'Delete',
    confirmCallback = () => {},
    cancelCallBack = () => {},
    ...restProps
}: Props) {
    let classNames: Array<string> = ['ct-remove-button'];
    if (className) {
        classNames.push(className);
    }

    const ref = React.useRef(null);

    const [isOpen, setIsOpen] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState<Element | null>(null);

    const handleClickOpen = (evt: React.MouseEvent) => {
        setIsOpen(true);
        setAnchorEl(evt.currentTarget);
    };

    const handleClose = (evt: React.MouseEvent): void => {
        evt.nativeEvent.stopImmediatePropagation();
        evt.stopPropagation();
        cancelCallBack();
        setIsOpen(false);
        setAnchorEl(null);
    };

    const handleRemove = (evt: React.MouseEvent): void => {
        evt.nativeEvent.stopImmediatePropagation();
        evt.stopPropagation();
        confirmCallback();
        setIsOpen(false);
        setAnchorEl(null);
    };

    const container = (document.querySelector('.ct-sidebar__portal') as HTMLElement) ?? undefined;

    return (
        <>
            <ThemeButton {...restProps} ref={ref} className={classNames.join(' ')} onClick={handleClickOpen}>
                {children ? children : 'Delete'}
            </ThemeButton>
            <DeleteConfirmationModal
                handleClose={handleClose}
                handleRemove={handleRemove}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                modalTitle={modalTitle}
                modalContent={modalContent}
                primaryButtonText={modalPrimaryButtonText}
                containerEl={container}
                anchorEl={anchorEl}
            />
        </>
    );
}
